// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__3AFA7","hasPosition":"Spinner_hasPosition__mnRqO","spinner":"Spinner_spinner__Mh_QD","rotation":"Spinner_rotation__fkuLO"};